import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormShare from '../../forms/FormShare.jsx';

const PageShare = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/site/shares/${_id}`,
    });
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Shares' },
  ];

  return (
    <>
      {_id === 'new' ? (
        <div>
          <Header breadcrumb={breadcrumb}>Create New</Header>
          <FormShare />
        </div>
      ) : (
        <PageHttp res={res}>
          {(doc) => (
            <>
              <Header breadcrumb={breadcrumb}>Editor</Header>
              <FormShare share={doc} />
            </>
          )}
        </PageHttp>
      )}
    </>
  );
};

export default PageShare;
